import { QueryClient } from "@tanstack/react-query";

/**
 * Shared TanStack Query client. Conservative defaults for an ops dashboard:
 * refetch on focus/reconnect, one retry, 30s stale time. Feature modules will
 * tune per-query options in a later phase.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
  },
});
